export const CLINICTYPE = [
  {
    id: 1,
    value: "Clinic type 1",
  },
  {
    id: 2,
    value: "Clinic type 2",
  },
  {
    id: 3,
    value: "Clinic type 3",
  },
  
];

export const CLINICLOCATION = [
  {
    id: 1,
    value: "Clinic location 1",
  },
  {
    id: 2,
    value: "Clinic location 2",
  },
  {
    id: 3,
    value: "Clinic location 3",
  },
  
];

export const NOOFAPPOINTMENTS = [
  {
    id: 1,
    value: "1",
  },
  {
    id: 2,
    value: "2",
  },
  {
    id: 3,
    value: "3",
  },
  
];

export const TIMINGSLOTDURATION = [
  {
    id: 1,
    value: "1",
  },
  {
    id: 2,
    value: "5",
  },
  {
    id: 3,
    value: "15",
  },
  {
    id: 4,
    value: "20",
  },
  {
    id: 5,
    value: "30",
  },
  {
    id: 6,
    value: "40",
  },
  {
    id: 7,
    value: "60",
  },
  
];
